import { apiSlice } from './apiSlice'

export interface Evidence {
  id: string
  case_id: string
  team_id: string
  title: string
  description?: string
  file_url: string
  file_name: string
  file_size: number
  mime_type: string
  category?: string
  tags: string[]
  uploaded_at?: string
  uploaded_by: string
  storage_path?: string
}

export interface EvidenceCreate {
  case_id: string
  team_id: string
  title: string
  description?: string
  category?: string
  tags?: string[]
  file: File
}

export const evidenceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvidence: builder.query<Evidence[], { case_id?: string; team_id?: string }>({
      query: (params) => ({
        url: '/evidence/list',
        params,
      }),
      providesTags: ['Evidence'],
    }),
    getEvidenceById: builder.query<Evidence, string>({
      query: (id) => `/evidence/${id}`,
      providesTags: (result, error, id) => [{ type: 'Evidence', id }],
    }),
    uploadEvidence: builder.mutation<Evidence, FormData>({
      query: (formData) => ({
        url: '/evidence/create',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Evidence'],
    }),
    deleteEvidence: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/evidence/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Evidence', id }],
    }),
    downloadEvidence: builder.query<Blob, string>({
      query: (id) => ({
        url: `/evidence/${id}/download`,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
})

export const {
  useGetEvidenceQuery,
  useGetEvidenceByIdQuery,
  useUploadEvidenceMutation,
  useDeleteEvidenceMutation,
  useLazyDownloadEvidenceQuery,
} = evidenceApi
